// extracted by mini-css-extract-plugin
module.exports = {"main":"NotFoundPage_main__8XKW_","link":"NotFoundPage_link__2c4GH"};